@use "@/styles/variables" as *;

.card {
	border: 1px solid $gray-200;
	border-radius: 12px;
	overflow: hidden;
	background: #ffffff;
}

// ── Toolbar (filter slot) ──────────────────────────────────────────────────────
.toolbar {
	padding: 10px 14px;
	border-bottom: 1px solid $gray-100;
	background: linear-gradient(180deg, #ffffff 0%, $gray-50 100%);
}

// ── Table ──────────────────────────────────────────────────────────────────────
.tableWrap {
	overflow-x: auto;
}

.table {
	width: 100%;
	border-collapse: collapse;

	thead {
		background: $gray-50;

		th {
			padding: 10px 12px;
			text-align: center;
			font-size: 0.75rem;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.04em;
			color: $gray-600;
			border-bottom: 1px solid $gray-200;
			white-space: nowrap;
		}
	}

	tbody {
		tr {
			border-bottom: 1px solid $gray-100;
			transition: background-color 0.15s ease;

			&:last-child {
				border-bottom: none;
			}

			&:hover {
				background-color: $gray-50;
			}
		}

		td {
			padding: 10px 12px;
			font-size: 0.875rem;
			vertical-align: middle;
			text-align: center;
			color: $gray-700;
		}
	}
}

// ── States ─────────────────────────────────────────────────────────────────────
.emptyCell {
	padding: 2rem 1rem;
	text-align: center;
	font-size: 0.875rem;
	font-style: italic;
	color: $gray-500;
}

.loadingState {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 2rem 1rem;
	color: $gray-500;
	font-size: 0.875rem;
	font-style: italic;
}

// ── Load more ──────────────────────────────────────────────────────────────────
.loadMore {
	display: flex;
	justify-content: center;
	padding: 10px 14px;
	border-top: 1px solid $gray-100;
}

.loadMoreButton {
	background: none;
	border: 1px solid $gray-200;
	border-radius: 8px;
	padding: 6px 16px;
	font-size: 0.8rem;
	font-weight: 600;
	color: $gray-500;
	cursor: pointer;
	transition:
		background-color 0.15s ease,
		color 0.15s ease,
		border-color 0.15s ease;

	&:hover {
		background-color: $gray-50;
		color: $gray-700;
		border-color: $gray-300;
	}
}
